<template>
  <div class="BidTB1">
    <v-container grid-list-md fluid fill-height>
      <v-layout row wrap justify-center>
      <v-flex xs12>
        <v-card>
          <v-expansion-panel
            v-model="panel"
            expand
            popout
          >
          </v-expansion-panel>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="info"
              :disabled="loadingFuida || loadingTable || vDate"
              @click="loadData()"
            >
              <v-icon left>cloud_download</v-icon>Cargar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
        <v-flex md10>
          <v-card class="mb-2">
            <v-card-title class="title">
              Tamaño de Empresas
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataVals1 === null">
                  <download-csv
                    :data="dataVals1"
                    name="ReporteEmpresa.csv"
                    :labels="labels"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text
              v-if="loadingFuida"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>
            <v-card-text v-else>
              <data-table
                :headers="headers1"
                :dataVals="dataVals1"
                :items="dataVals1"
                :key="tableKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex md10>
          <v-card class="mb-2">
            <v-card-title class="title">
              Tamaño de Empresas - Tratamiento y control
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="dataVals2 === null">
                  <download-csv
                    :data="dataVals2"
                    name="ReportesEmpresaTratamiento.csv"
                    :labels="labels"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text
              v-if="loadingFuida"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>
            <v-card-text v-else>
              <data-table
                :headers="headers2"
                :dataVals="dataVals2"
                :items="dataVals2"
                :key="tableKey"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableBase'
import JsonCSV from 'vue-json-csv'
import moment from 'moment'

export default {
  name: 'BidTB1',

  components: {
    'data-table': dataTable,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
  },

  data: function () {
    return {
      backConf: {
        path: '/projects/bid_tb1/',
        page: 1
      },

      loadingFuida: false,
      loadingTable: false,
      progressSize: 70,
      progressWidth: 7,
      operativo: null,

      panel: [false],

      filter: [],

      arreglo: [],

      filterBy: null,

      headers1: [
        { text: 'Tamaño', value: 'tamano', align: 'left' },
        { text: 'Número de Empresas', value: 'total',  align: 'left' },
        { text: 'Porcentaje %', value: 'porcentaje', align: 'left' }
      ],
      headers2: [
        { text: 'Tamaño', value: 'tamano', align: 'left' },
        { text: 'Dominio', value: 'tratamiento', align: 'left' },
        { text: 'Número de Empresas', value: 'total', align: 'left' },
        { text: 'Porcentaje %', value: 'porcentaje', align: 'left' }
      ],

      dataVals1: null,
      dataVals2: null,
      tableKey: 0
    }
  },

  methods: {
    /** Carga la tabla
     */
    loadTable () {
      this.dataVals1 = null
      this.dataVals2 = null
      this.loadingFuida = true
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {

          filtro: this.filterToApply
        }
      }

      let t = this

      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals1 = resp.data[0].te
          t.dataVals2 = resp.data[0].tet
          t.loadingFuida = false
          t.tableKey += 1
        })
        .catch(function (err) {
          console.error(err)
          t.dataVals1 = null
          t.dataVals2 = null
          t.loadingFuida = false
        })
    },
    loadFiltro () {
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo,
          tipo: 'filtro'
        }
      }
      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.filterBy = resp.data
        })
        .catch(function (err) {
          t.filterBy = null
          console.error(err)
        })
    },
    loadData () {
      this.loadTable()
      this.panel = [false]
    },
  }
}
</script>
